/**
 * Minimum lane assignment: overlapping intervals must use different lanes.
 * Greedy interval partitioning — optimal (minimum) lane count.
 */

const EPS = 1e-4;

/**
 * @param {Array<{ id: string, start: number, end: number }>} items
 * @returns {{ items: typeof items, laneCount: number }}
 */
export function assignMinimumLanes(items) {
  if (!items?.length) {
    return { items: [], laneCount: 0 };
  }

  const sorted = [...items].sort(
    (a, b) => a.start - b.start || a.end - b.end || String(a.id).localeCompare(String(b.id)),
  );
  const trackEnds = [];

  for (const item of sorted) {
    let lane = -1;
    for (let t = 0; t < trackEnds.length; t += 1) {
      if (trackEnds[t] <= item.start + EPS) {
        lane = t;
        trackEnds[t] = item.end;
        break;
      }
    }
    if (lane < 0) {
      lane = trackEnds.length;
      trackEnds.push(item.end);
    }
    item.lane = lane;
  }

  return { items: sorted, laneCount: trackEnds.length };
}

/** True when [a0,a1) and [b0,b1) overlap in time. */
export function intervalsOverlap(a0, a1, b0, b1) {
  return a0 < b1 - EPS && b0 < a1 - EPS;
}
